export enum ApplicationStepStatus {
  /**Step is active if it is at least partially filled  */
  ACTIVE = 'ACTIVE',
  /**Step is completed if running the step validation on it gives no errors */
  COMPLETE = 'COMPLETE',
  /**Step is incomplete if running the step validation on it gives any errors */
  INCOMPLETE = 'INCOMPLETE',
}
